import { LATE_FEE_RATE } from './settings'

const { FIXED, PERCENTAGE } = LATE_FEE_RATE

export const getIsFeeRateFixed = feeRate => feeRate === FIXED.value
export const getIsFeeRatePercentage = feeRate => feeRate === PERCENTAGE.value
